import React from "react";
import { Col, Container, Row, Modal, Form, Button } from "react-bootstrap";
import bnb from "./layout_assets/bnb_lay.svg";
import meta from "./layout_assets/meta_lay.svg";
import { BsXCircle } from "react-icons/bs";
import "./modale.css";

export default function Modale({ show, handleClose }) {
  return (
    <>
      <Container className="Modalee">
        <Row>
          <Col>
            <Modal show={show} onHide={handleClose} centered>
              <Modal.Header className="head_modale d-flex justify-content-end">
                <BsXCircle
                  className="text-white btn-cross"
                  onClick={handleClose}
                />
              </Modal.Header>
              <Modal.Body className="head_modale">
                <div>
                  <span>Connect Network</span>
                </div>
                <Form>
                  <Form.Select
                    aria-label="Default-select-example"
                    className="mt-1 mb-3 modale_input"
                    size="lg"
                  >
                    <option value="1" className="modale_input_option rounded">
                      <img src={bnb} alt="" />
                      <span>BEP20</span>
                    </option>
                    <option value="2" className="modale_input_option rounded">
                      <img src={bnb} alt="" />
                      <span>BEP20</span>
                    </option>
                    <option value="3" className="modale_input_option rounded">
                      <span>BEP20</span>
                    </option>
                  </Form.Select>
                  <Form.Select
                    aria-label="Default-select-example"
                    className="mb-3 modale_input"
                    size="lg"
                  >
                    <img src={meta} alt="" />
                    <option value="1" className="modale_input_option rounded">
                      <span>Company 1</span>
                    </option>
                    <option value="2" className="modale_input_option rounded">
                      <img src={meta} alt="" />
                      <span>Company 2</span>
                    </option>
                    <option
                      value="3"
                      className="modale_input_option rounded"
                    >
                      <span>Company 3</span>
                    </option>
                  </Form.Select>

                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Control
                      size="lg"
                      className="modale_input"
                      type="text"
                      placeholder="Referral ID (optional)"
                      autoFocus
                    />
                  </Form.Group>
                  <div>
                    <Button className="w-100 modale_btn fw-bold">Connect Wallet</Button>
                  </div>
                </Form>
              </Modal.Body>
            </Modal>
          </Col>
        </Row>
      </Container>
    </>
  );
}
